"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExternalApplicationUser = exports.defaultExternalApplication = void 0;
exports.defaultExternalApplication = {
    externalApplicationName: "",
    isActive: false,
    organizationId: -1,
    organizationName: ""
};
exports.defaultExternalApplicationUser = {
    alias: "",
    userId: undefined,
    username: "",
    externalApplicationId: undefined,
    externalApplicationName: ""
};
//# sourceMappingURL=external-application.js.map